import Vue from 'vue'
import store from '@/store'
import {getDictTypeByNameValues} from "@/api/home";


/* 
  字典值列表
  例 van-field + picker 
    性别： 男 女  其他
  <van-field v-model="aaa" is-link label="性别" v-dict="'EB863031m12C1C00E93210K642fA6341'" name="picker" @click="showPicker = true" />
  <van-popup v-model:show="showPicker" position="bottom">
    <van-picker :columns="dict['EB863031m12C1C00E93210K642fA6341']" :columns-field-names="customFieldName" @cancel="showPicker = false" @confirm="onConfirm" />
  </van-popup>
*/
export const d_dict = {
  bind: function (el, binding, vnode) {
    let dictKey = binding.value
    if (!store.state.dict[dictKey]) {

    }
  }
}

/* 
  字典值取值
  例： 性别： 男
  <span  v-dict-value="{typeId:'EB863031m12C1C00E93210K642fA6341', value: '1'}"></span>
*/
export const d_dictValue = {
  bind: function (el, binding, vnode) {
    showDictValue(el, binding, vnode)
  },
  update: function (el, binding, vnode) {
    if (binding.value != binding.oldValue) {
      showDictValue(el, binding, vnode)
    }
  }
}

function showDictValue(el, binding) {
  let dictTypeId = binding.value.typeId
  let value = binding.value.value
  let valueSz = []
  if (value) {
    valueSz = value.split(',')
  }
  var textValue = []
  if (!store.state.dict[dictTypeId]) {
    getDictTypeByNameValues(dictTypeId).then(res => {
      if (res.code == 0) {
        store.commit('SET_DICT_TYPE', {
          dictTypeId,
          typeList: res.data
        })
        res.data.map(item => {
          valueSz.map(valueItem => {
            if (item.dictValue === '' + valueItem) {
              textValue.push(item.dictName)
            }
          })
        })
        el.innerText = textValue.join(',')
      }
    })
  } else {
    let dictList = store.state.dict[dictTypeId]
    dictList.map((item, index) => {
      valueSz.map((valueItem, valueIndex) => {
        if (item.dictValue === '' + valueItem) {
          textValue.push(item.dictName)
        }
      })
    })
    el.innerText = textValue.join(',')
  }
}
